{
  "de": {
    "place1": "Simvastatin",
    "place2": "Clarithromycin",
    "title": "Anticholinerge Effekte",
    "label": "Kein erhöhtes Risiko für anticholinerge Effekte erkannt.",
    "label_na": "Geben Sie zuerst Wirkstoffe ein, damit das Risiko für anticholinerge Effekte durch Wirkstoffe beurteilt werden kann.",
    "nowirkstoff": "Keine Wirkstoffe ausgewählt.",
    "bewertung": "Bewertung",
    "empfehlung": "Empfehlung",
    "scene1a1": "Simvastatin beeinflusst das anticholinerge System nur mild.",
    "scene1a2": "Simvastatin und Clarithromycin beeinflussen das anticholinerge System nur mild.",
    "scene1b1": "Simvastatin moduliert das anticholinerge System in moderatem Ausmass.",
    "scene1c": "Das Risiko für ein anticholinerge Syndrom ist bei dieser Medikation eher als gering einzustufen, wenn die Dosierung sich im üblichen Bereich befindet.",
    "scene1d": "Insbesondere nach einer Dosiserhöhung und bei Dosierungen im oberen therapeutischen Bereich sollte vorsichtshalber auf anticholinerge Symptome geachtet werden.",
    "scene2a1": "Das Simvastatin erhöht die anticholinerge Aktivität stark.",
    "scene2a2": "Gemeinsam erhöhen Simvastatin und Clarithromycin die anticholinerge Aktivität.",
    "scene2sto": "stark",
    "scene2mod": "moderat",
    "scene2mil": "mild",
    "scene2emp1": "Das Risiko für anticholinerge Nebenwirkungen wie Verschwommensehen, Verwirrtheit und Tremor ist unter dieser Therapie erhöht.",
    "scene2emp2": "Nach Möglichkeit sollte die Therapie umgestellt werden oder der Patient engmaschig auf weitere Symptome wie z.B. Obstipation, Mydriasis und verminderte Vigilanz monitorisiert werden.",
    "scene4a1": "Gemäss unseren Erkenntnisse erhöht Simvastatin nicht die anticholinerge Aktivität.",
    "scene4a2": "Gemäss unseren Erkenntnissen erhöhen weder Simvastatin noch Clarithromycin die anticholinerge Aktivität.",
    "scene4b1": "Der anticholinerge Effekt von Simvastatin ist nicht relevant.",
    "scene4b2": "Die anticholinergen Effekt von Simvastatin und Clarithromycin sind nicht relevant.",
    "scene1stim": "Symptome",
    "alt": "Transmitter",
    "table_score": "Scores",
    "table_points": "Punkte",
    "antic_prefix": "Symbol (b):",
    "antic_limit": "Risiko ab 3 Punkten erhöht."
  },
  "en": {
    "place1": "simvastatin",
    "place2": "clarithromycin",
    "title": "Anticholinergic effects",
    "label": "No increased risk of anticholinergic effects detected.",
    "label_na": "First enter active substances so that the risk of anticholinergic effects from active substances can be assessed.",
    "nowirkstoff": "No active substance selected.",
    "bewertung": "Rating",
    "empfehlung": "Recommendation",
    "scene1a1": "Simvastatin only has a mild effect on the anticholinergic system.",
    "scene1a2": "Simvastatin and clarithromycin only have a mild effect on the anticholinergic system.",
    "scene1b1": "Simvastatin modulates the anticholinergic system to a moderate extent.",
    "scene1c": "The risk of anticholinergic syndrome with this medication is rather low if the dosage is in the usual range.",
    "scene1d": "As a precaution, attention should be paid to anticholinergic symptoms, especially after increasing the dose and at doses in the upper therapeutic range.",
    "scene2a1": "The simvastatin greatly increases anticholinergic activity.",
    "scene2a2": "Together, simvastatin and clarithromycin increase anticholinergic activity.",
    "scene2sto": "strong",
    "scene2mod": "moderate",
    "scene2mil": "mild",
    "scene2emp1": "The risk of anticholinergic side effects such as blurred vision, confusion and tremor is increased with this therapy.",
    "scene2emp2": "If possible, the therapy should be switched or the patient should be closely monitored for other symptoms, such as constipation, mydriasis and reduced vigilance.",
    "scene4a1": "According to our knowledge, simvastatin does not increase anticholinergic activity.",
    "scene4a2": "According to our knowledge, neither simvastatin nor clarithromycin increase anticholinergic activity.",
    "scene4b1": "The anticholinergic effect of simvastatin is not relevant.",
    "scene4b2": "The anticholinergic effects of simvastatin and clarithromycin are not relevant.",
    "scene1stim": "symptoms",
    "alt": "transmitter",
    "table_score": "Scores",
    "table_points": "Points",
    "antic_prefix": "Symbol (b):",
    "antic_limit": "Increased risk from 3 points."
  },
  "fr": {
    "place1": "simvastatine",
    "place2": "clarithromycine",
    "title": "Effets anticholinergiques",
    "label": "Pas de risque accru d'effets anticholinergiques détectés.",
    "label_na": "Saisissez d'abord les substances actives afin d'évaluer le risque d'effets anticholinergiques des substances actives.",
    "nowirkstoff": "Aucune substance active sélectionnée.",
    "bewertung": "Notation",
    "empfehlung": "Recommandation",
    "scene1a1": "La simvastatine n'a qu'un effet modéré sur le système anticholinergique.",
    "scene1a2": "La simvastatine et la clarithromycine n'ont qu'un effet modéré sur le système anticholinergique.",
    "scene1b1": "La simvastatine module modérément le système anticholinergique.",
    "scene1c": "Le risque de syndrome anticholinergique avec ce médicament est plutôt faible si la dosage est respecté.",
    "scene1d": "Par mesure de précaution, une attention particulière doit être portée aux symptômes anticholinergiques, en particulier après augmentation de la dose et à de celles situées dans la marge thérapeutique supérieure.",
    "scene2a1": "La simvastatine augmente considérablement l'activité anticholinergique.",
    "scene2a2": "Ensemble, la simvastatine et la clarithromycine augmentent l'activité anticholinergique.",
    "scene2sto": "fort",
    "scene2mod": "modéré",
    "scene2mil": "bénin",
    "scene2emp1": "Le risque d'effets secondaires anticholinergiques tels qu'une vision floue, une confusion et des tremblements est accru avec cette thérapie.",
    "scene2emp2": "Si possible, le traitement doit être changé ou le patient doit être étroitement surveillé pour d'autres symptômes, tels que la constipation, la mydriase et une vigilance réduite.",
    "scene4a1": "À notre connaissance, la simvastatine n'augmente pas l'activité anticholinergique.",
    "scene4a2": "À notre connaissance, ni la simvastatine ni la clarithromycine n'augmentent l'activité anticholinergique.",
    "scene4b1": "L'effet anticholinergique de la simvastatine n'est pas pertinent.",
    "scene4b2": "Les effets anticholinergiques de la simvastatine et de la clarithromycine ne sont pas pertinents.",
    "scene1stim": "symptômes",
    "alt": "transmetteur",
    "table_score": "Notes",
    "table_points": "Points",
    "antic_prefix": "Symbol (b):",
    "antic_limit": "Augmentation du risque à partir de 10 points."
  },
  "it": {
    "place1": "simvastatina",
    "place2": "claritromicina",
    "title": "Effetti anticolinergici",
    "label": "Nessun aumento del rischio di effetti anticolinergici rilevato. ",
    "label_na": "Per poter valutare il rischio di effetti anticolinergici inserire innanzitutto il *nome dei* principi attivi.",
    "nowirkstoff": "Nessun principio attivo selezionato.",
    "bewertung": "Valutazione",
    "empfehlung": "Avvertenze e precauzioni",
    "scene1a1": "Somministrata unicamente, la Simvastatina possiede lievi effetti anticolinergici.",
    "scene1a2": "La simvastatina e la claritromicina possiedono soltanto limitati effetti anticolinergici.",
    "scene1b1": "La Simvastatina è in grado di stimolare una risposta di tipo anticolinergica in misura assai moderata. ",
    "scene1c": "Il rischio di sindrome anticolinergica è molto basso se si rispettano i dosaggi abituali. ",
    "scene1d": "Per precauzione, si dovrebbe porre attenzione ai sintomi di tipo anticolinergico, soprattutto se il dosaggio è stato aumentato oppure se è al di sopra dell'intervallo terapeutico. ",
    "scene2a1": "La simvastatina aumenta notevolmente gli effetti anticolinergici.",
    "scene2a2": "La co-somministrazione di simvastatina e claritromicina aumenta l'attività anticolinergica. ",
    "scene2sto": "forte",
    "scene2mod": "moderato",
    "scene2mil": "lieve",
    "scene2emp1": "Il rischio di effetti indesiderati di tipo anticolinergico tra i quali vista annebbiata, confusione e tremori aumenta utilizzando questo tipo di terapia",
    "scene2emp2": "Se possibile, la terapia dovrebbe essere modificata oppure il paziente dovrebbe essere attentamente monitorato se compaiono sintomi come costipazione, midriasi e/o sonnolenza.",
    "scene4a1": "Sulla base dei dati a nostra disposizione, la simvastatina non causa un aumento dell'attività anticolinergica.",
    "scene4a2": "Sulla base dei dati a nostra disposizione, né la simvastatina né la claritromicina causano un aumento dell'attività anticolinergica.",
    "scene4b1": "L'effetto anticolingerico della simvastatina non è rilevante. ",
    "scene4b2": "Gli effetti anticolinergici della simvastatina e della claritromicina non sono rilevanti. ",
    "scene1stim": "sintomi",
    "alt": "trasmettitore",
    "table_score": "Punteggio",
    "table_points": "Punti",
    "antic_prefix": "Simbolo (b):",
    "antic_limit": "Aumento del rischio di 3 punti."
  },
  "es": {
    "place1": "simvastatina",
    "place2": "claritromicina",
    "title": "Efectos anticolinérgicos",
    "label": "No se detectó un mayor riesgo de efectos anticolinérgicos.",
    "label_na": "Introduzca primero las sustancias activas para poder evaluar el riesgo de efectos anticolinérgicos de las sustancias activas.",
    "nowirkstoff": "No se seleccionó ninguna sustancia activa.",
    "bewertung": "Clasificación",
    "empfehlung": "Recomendación",
    "scene1a1": "La simvastatina solo tiene un efecto leve sobre el sistema anticolinérgico.",
    "scene1a2": "La Simvastatina y claritromicina solo tienen un efecto leve sobre el sistema anticolinérgico.",
    "scene1b1": "La Simvastatina modula el sistema anticolinérgico de forma moderada.",
    "scene1c": "El riesgo de síndrome anticolinérgico con este medicamento es relativamente bajo si la dosis se encuentra en el rango habitual.",
    "scene1d": "Como precaución, se debe prestar atención a los síntomas anticolinérgicos, especialmente después de aumentar la dosis y en dosis en el rango terapéutico superior.",
    "scene2a1": "La simvastatina aumenta en gran medida la actividad anticolinérgica.",
    "scene2a2": "La simvastatina y la claritromicina combinadas aumentan la actividad anticolinérgica.",
    "scene2sto": "severo",
    "scene2mod": "moderado",
    "scene2mil": "leve",
    "scene2emp1": "El riesgo de efectos secundarios anticolinérgicos como visión borrosa, confusión y temblor aumenta con esta terapia.",
    "scene2emp2": "Si es posible, se debe cambiar la terapia o el paciente debe ser monitoreado de cerca por otros síntomas, como estreñimiento, midriasis e hipovigilancia.",
    "scene4a1": "Según nuestro conocimiento, la simvastatina no aumenta la actividad anticolinérgica.",
    "scene4a2": "Según nuestro conocimiento, ni la simvastatina ni la claritromicina aumentan la actividad anticolinérgica.",
    "scene4b1": "El efecto anticolinérgico de la simvastatina no es relevante.",
    "scene4b2": "Los efectos anticolinérgicos de la simvastatina y la claritromicina no son relevantes.",
    "scene1stim": "síntomas",
    "alt": "transmisor",
    "table_score": "Puntuaciones",
    "table_points": "Puntos",
    "antic_prefix": "Símbolo (b):",
    "antic_limit": "Riesgo aumentado desde 3 puntos."
  },
  "ru": {
    "place1": "симвастатин",
    "place2": "кларитромицин",
    "title": "Антихолинергические эффекты",
    "label": "Повышенного риска антихолинергических эффектов не обнаружено.",
    "label_na": "Сначала введите активные вещества, чтобы можно было оценить риск антихолинергических эффектов активных веществ.",
    "nowirkstoff": "Активное вещество не выбрано.",
    "bewertung": "Рейтинг",
    "empfehlung": "Рекомендация",
    "scene1a1": "Симвастатин слабо влияет на холинолитическую систему.",
    "scene1a2": "Симвастатин и кларитромицин слабо влияют на холинолитическую систему.",
    "scene1b1": "Симвастатин в умеренной степени модулирует антихолинергическую систему.",
    "scene1c": "Риск холинолитического синдрома при приеме этого лекарства довольно низок, если дозировка находится в обычном диапазоне.",
    "scene1d": "В качестве меры предосторожности следует обращать внимание на симптомы холинолитиков, особенно после увеличения дозы и при дозах в верхнем терапевтическом диапазоне.",
    "scene2a1": "Симвастатин значительно увеличивает холинолитическую активность.",
    "scene2a2": "Вместе симвастатин и кларитромицин усиливают холинолитическую активность.",
    "scene2sto": "сильный",
    "scene2mod": "умеренный",
    "scene2mil": "незначительный",
    "scene2emp1": "Риск антихолинергических побочных эффектов, таких как помутнение зрения, спутанность сознания и тремор, увеличивается с этой терапией.",
    "scene2emp2": "По возможности следует изменить терапию или внимательно наблюдать за пациентом на предмет других симптомов, таких как запор, мидриаз и снижение бдительности.",
    "scene4a1": "По нашим данным, симвастатин не увеличивает холинолитическую активность.",
    "scene4a2": "По нашим данным, ни симвастатин, ни кларитромицин не увеличивают холинолитическую активность.",
    "scene4b1": "Антихолинергический эффект симвастатина не имеет значения.",
    "scene4b2": "Антихолинергические эффекты симвастатина и кларитромицина не имеют значения.",
    "scene1stim": "симптомы",
    "alt": "передатчик",
    "table_score": "Очки",
    "table_points": "Точки",
    "antic_prefix": "Символ (б):",
    "antic_limit": "Повышенный риск с 3 баллов."
  },
  "pt": {
    "place1": "sinvastatina",
    "place2": "claritromicina",
    "title": "Efeitos anticolinérgicos",
    "label": "Nenhum risco aumentado de efeitos anticolinérgicos detectados.",
    "label_na": "Primeiro, insira as substâncias ativas para que o risco de efeitos anticolinérgicos das substâncias ativas possa ser avaliado.",
    "nowirkstoff": "Nenhuma substância ativa selecionada.",
    "bewertung": "Avaliação",
    "empfehlung": "Recomendação",
    "scene1a1": "A sinvastatina tem um efeito moderado no sistema anticolinérgico.",
    "scene1a2": "A sinvastatina e a claritromicina têm um efeito moderado no sistema anticolinérgico.",
    "scene1b1": "A sinvastatina modula o sistema anticolinérgico em grau moderado.",
    "scene1c": "O risco de síndrome anticolinérgica com este medicamento é bastante baixo se a dosagem estiver na faixa normal.",
    "scene1d": "Como precaução, deve-se prestar atenção aos sintomas anticolinérgicos, especialmente após o aumento da dose e em doses na faixa terapêutica superior.",
    "scene2a1": "A sinvastatina aumenta muito a atividade anticolinérgica.",
    "scene2a2": "Juntas, a sinvastatina e a claritromicina aumentam a atividade anticolinérgica.",
    "scene2sto": "forte",
    "scene2mod": "moderado",
    "scene2mil": "suave",
    "scene2emp1": "O risco de efeitos colaterais anticolinérgicos, como visão turva, confusão e tremor, aumenta com esta terapia.",
    "scene2emp2": "Se possível, a terapia deve ser trocada ou o paciente deve ser monitorado de perto para outros sintomas, como prisão de ventre, midríase e vigilância reduzida.",
    "scene4a1": "De acordo com nosso conhecimento, a sinvastatina não aumenta a atividade anticolinérgica.",
    "scene4a2": "De acordo com nosso conhecimento, nem a sinvastatina nem a claritromicina aumentam a atividade anticolinérgica.",
    "scene4b1": "O efeito anticolinérgico da sinvastatina não é relevante.",
    "scene4b2": "Os efeitos anticolinérgicos da sinvastatina e claritromicina não são relevantes.",
    "scene1stim": "sintomas",
    "alt": "transmissor",
    "table_score": "Pontuações",
    "table_points": "Pontos",
    "antic_prefix": "Símbolo (b):",
    "antic_limit": "Risco aumentado de 3 pontos."
  },
  "zh": {
    "place1": "辛伐他汀",
    "place2": "克拉霉素",
    "title": "抗胆碱能作用",
    "label": "未检测到抗胆碱能作用的风险增加。",
    "label_na": "首先输入活性物质，以便评估活性物质的抗胆碱能作用风险。",
    "nowirkstoff": "未选择活性物质。",
    "bewertung": "评分",
    "empfehlung": "推荐",
    "scene1a1": "辛伐他汀仅对抗胆碱能系统有轻微影响。",
    "scene1a2": "辛伐他汀和克拉霉素仅对抗胆碱能系统有轻微影响。",
    "scene1b1": "辛伐他汀适度调节抗胆碱能系统。",
    "scene1c": "如果剂量在通常范围内，使用这种药物发生抗胆碱能综合征的风险相当低。",
    "scene1d": "作为预防措施，应注意抗胆碱能症状，尤其是在增加剂量后和剂量在治疗上限时。",
    "scene2a1": "辛伐他汀大大增加抗胆碱能活性。",
    "scene2a2": "辛伐他汀和克拉霉素一起增加抗胆碱能活性。",
    "scene2sto": "强的",
    "scene2mod": "缓和",
    "scene2mil": "温和的",
    "scene2emp1": "这种疗法会增加抗胆碱能副作用的风险，例如视力模糊、意识模糊和震颤。",
    "scene2emp2": "如果可能，应更换治疗方法或密切监测患者的其他症状，如便秘、瞳孔散大和警惕性降低。",
    "scene4a1": "据我们所知，辛伐他汀不会增加抗胆碱能活性。",
    "scene4a2": "据我们所知，辛伐他汀和克拉霉素都不会增加抗胆碱能活性。",
    "scene4b1": "辛伐他汀的抗胆碱能作用不相关。",
    "scene4b2": "辛伐他汀和克拉霉素的抗胆碱能作用不相关。",
    "scene1stim": "症状",
    "alt": "发射机",
    "table_score": "分数",
    "table_points": "积分",
    "antic_prefix": "符号 (b)：",
    "antic_limit": "从 3 点增加风险。"
  },
  "ar": {
    "place1": "سيمفاستاتين",
    "place2": "كلاريثروميسين",
    "title": "تأثيرات مضادات الكولين",
    "label": "لم يتم الكشف عن زيادة خطر حدوث تأثيرات مضادات الكولين.",
    "label_na": "أدخل أولاً المواد الفعالة بحيث يمكن تقييم مخاطر تأثيرات مضادات الكولين من المواد الفعالة.",
    "nowirkstoff": "لم يتم اختيار مادة فعالة.",
    "bewertung": "تقييم",
    "empfehlung": "توصية",
    "scene1a1": "Simvastatin له تأثير خفيف فقط على نظام مضادات الكولين.",
    "scene1a2": "Simvastatin و Clarithromycin لهما تأثير خفيف فقط على نظام مضادات الكولين.",
    "scene1b1": "ينظم Simvastatin نظام مضادات الكولين إلى حد معتدل.",
    "scene1c": "يكون خطر الإصابة بمتلازمة مضادات الكولين مع هذا الدواء منخفضًا إلى حد ما إذا كانت الجرعة في النطاق المعتاد.",
    "scene1d": "كإجراء احترازي ، يجب الانتباه إلى أعراض مضادات الكولين ، خاصة بعد زيادة الجرعة وعند الجرعات في النطاق العلاجي العلوي.",
    "scene2a1": "يزيد سيمفاستاتين بشكل كبير من نشاط مضادات الكولين.",
    "scene2a2": "يعمل سيمفاستاتين وكلاريثروميسين معًا على زيادة نشاط مضادات الكولين.",
    "scene2sto": "قوي",
    "scene2mod": "معتدل",
    "scene2mil": "خفيف",
    "scene2emp1": "يزداد خطر الآثار الجانبية لمضادات الكولين مثل عدم وضوح الرؤية والارتباك والرعشة مع هذا العلاج.",
    "scene2emp2": "إذا أمكن ، يجب تبديل العلاج أو يجب مراقبة المريض عن كثب بحثًا عن أعراض أخرى ، مثل الإمساك وتوسع حدقة العين وتقليل اليقظة.",
    "scene4a1": "وفقًا لمعرفتنا ، لا يزيد سيمفاستاتين من نشاط مضادات الكولين.",
    "scene4a2": "وفقًا لمعرفتنا ، لا يزيد سيمفاستاتين ولا كلاريثروميسين نشاط مضادات الكولين.",
    "scene4b1": "التأثير المضاد للكولين لسيمفاستاتين غير مناسب.",
    "scene4b2": "تأثيرات مضادات الكولين من سيمفاستاتين وكلاريثروميسين ليست ذات صلة.",
    "scene1stim": "أعراض",
    "alt": "الارسال",
    "table_score": "درجات",
    "table_points": "نقاط",
    "antic_prefix": "الرمز (ب):",
    "antic_limit": "زيادة المخاطر من 3 نقاط."
  }
}